export default __webpack_public_path__ + "5b4b16b875bf8ba07ca286d3510b2a0b.ico";